@if (_gridElements && _gridElements?.length > 0 && !(loading$ | async) && !hasError) {
  <div class="sh-content-grid-wrapper">
    <sh-table-head
      [availableSelect]="availableSelect"
      [availableActionItems]="!!actionItems"
      [itemsSelectedLabelKey]="itemsSelectedLabelKey"
      [noItemsSelectedLabelKey]="noItemsSelectedLabelKey"
      [canBatchSelect]="canBatchSelect"
      [selectedItemsCount]="selectedItemsCount"
      [selectedPageItemsCount]="selectedPageItems"
      [totalPageItemsCount]="_gridElements.length"
      [isInitialBulk]="isInitialBulk"
      [contextActionGroup]="contextActionGroup"
      (selectionChanged)="onSelectionChanged($event)"
      >
      @if (_gridElements) {
        <ul [ngClass]="activeItem ? 'sh-content-grid--narrow' : 'sh-content-grid'">
          @switch (gridType) {
            @case (gridTypes.RECORD) {
              @for (gridElement of _gridElements; track trackByFunction(i, gridElement); let i = $index) {
                <li class="sh-content-grid__item">
                  @defer (on viewport; prefetch on idle) {
                  <sh-generic-grid-item
                    [gridType]="gridType"
                    [availableSelect]="availableSelect"
                    [disableSelect]="disableSelect"
                    [disableSelectMessage]="disableSelectMessage"
                    [selectionMode]="_selectedElements?.length > 0"
                    [selected]="isGridItemSelected(gridElement)"
                    [active]="isGridItemActive(gridElement)"
                    [item]="gridElement"
                    [actionGroup]="_gridElementsActionGroups[i]"
                    [pictureFillMode]="pictureFillMode"
                    [isClickable]="areItemsClickable"
                    (selectItem)="selectGridItem(gridElement, $event)"
                    (clickItem)="clickGridItem(gridElement)"
                    (clickOverlay)="clickGridItemOverlay(gridElement)"
                  ></sh-generic-grid-item>
                  } @placeholder {
                  <div class="grid-item-placeholder"></div>
                }
              </li>
            }
          }
          @default {
            @for (gridElement of _gridElements; track trackByFunction(i, gridElement); let i = $index) {
              <li class="sh-content-grid__item">
                @defer (on viewport; prefetch on idle) {
                <sh-generic-grid-item
                  [gridType]="gridType"
                  [availableSelect]="availableSelect"
                  [selectionMode]="_selectedElements?.length > 0"
                  [selected]="isGridItemSelected(gridElement)"
                  [active]="isGridItemActive(gridElement)"
                  [item]="gridElement"
                  [isClickable]="areItemsClickable"
                  (selectItem)="selectGridItem(gridElement, $event)"
                  (clickItem)="clickGridItem(gridElement)"
                  (clickOverlay)="clickGridItemOverlay(gridElement)"
                ></sh-generic-grid-item>
                } @placeholder {
                <div class="grid-item-placeholder"></div>
              }
            </li>
          }
        }
      }
    </ul>
  }
</sh-table-head>
</div>
} @else {
  <div class="sh-card-table-wrapper">
    <table class="sh-card-table">
      <thead>
        <th scope="col"></th>
      </thead>
      <tbody>
        @if (loading$ | async) {
          <tr id="generic-grid-loading-row">
            <td style="width: 2000vw">{{ loadingMsg }}</td>
          </tr>
        }
        @if (hasError && !(loading$ | async)) {
          <tr id="generic-grid-error-row" class="sh-card-table__row--error">
            <td style="width: 2000vw">{{ loadingFailedMsg }}</td>
          </tr>
        }
        @if (!hasError && _gridElements && _gridElements?.length === 0 && !(loading$ | async)) {
          <tr class="sh-card-table__row--update">
            <td style="width: 2000vw">{{ emptyListMsg }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

